
.dda-information-card-image {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0;
  overflow: hidden;
}
